<div *ngIf="{criterios: criterios$ | async, columnas: columnas$ | async} as data">
  <nav class="feedback-header feedback-grid-header">
    <!-- <div> -->
    <div class="responsive">
      <button [routerLink]="['/', 'estudio', 'unidad', unidadId]" fragment="evidencias" mat-icon-button color="primary"
        matTooltip="Regresar a evidencias">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <label *ngIf="evento$ | async as evento" [matTooltip]="evento.resumenTXT"
        class="ev-label">{{evento.nombre}}</label>
    </div>
    <div *ngIf="eventoIndex$ | async as eventoIndex">
      <div class="responsive item-list-nav">
      <button (click)="navegarEvento(eventoIndex.index -1, eventoIndex.eventos)" *ngIf="eventoIndex.index > 0"
        mat-button>
        <mat-icon>navigate_before</mat-icon>
        <mat-label>Anterior</mat-label>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <div *ngFor="let evento of eventoIndex.eventos; index as i">
          <button (click)="navegarEvento(i, eventoIndex.eventos)" mat-menu-item>
            <div class="evidence-menu"><span class="evidence-menu__label">{{evento.evento.nombre}}</span>
            </div>
          </button>
        </div>
      </mat-menu>
      <button (click)="navegarEvento(eventoIndex.index + 1, eventoIndex.eventos)"
        *ngIf="eventoIndex.eventos && eventoIndex.eventos.length - 1 > eventoIndex.index && eventoIndex.index > -1"
        mat-button>

        <mat-label>Siguiente</mat-label>
        <mat-icon>navigate_next</mat-icon>
      </button>
    </div>
    </div>
    <!-- </div> -->
  </nav>
  <div *ngIf="alumnos$ | async as alumnos; else loading">
    <div *ngIf="loading$ | async; else loading">
      <div *ngIf="data.criterios && data.columnas; else loading">
        <app-retroalimentacion-grid-tabla *ngIf="alumnoForm.value === -1; else alumno" [alumnos$]="alumnos$"
          [eventoUnidadId]="eventoUnidadId" [columnas]="data.columnas" [fechasEvento$]="fechasEvento$"
          [criterios]="data.criterios" [fechaActual$]="fechaActual$" [evento$]="evento$" [alumnoForm]="alumnoForm"
          [fechaForm]="fechaForm" [materiaForm]="materiaForm" [checkForm]="checkForm" [materias$]="materias$"
          (classroomActionEvent)="classroomActions($event.alumnos, $event.accion)"
          [mostrarAutoevaluacionForm]="mostrarAutoevaluacionForm"
          [mostrarAutoevaluacion$]="mostrarAutoevaluacion$"
          (navegarEstudianteEvent)="navegarEstudiante($event.id)">
        </app-retroalimentacion-grid-tabla>
        <ng-template #alumno>
          <app-retroalimentacion-trabajo-alumno [alumnos]="alumnos" [alumnos$]="alumnos$"
            [eventoUnidadId$]="eventoUnidadId$" [fechasEvento$]="fechasEvento$" [criterios]="data.criterios"
            [fechaActual$]="fechaActual$" [alumnoForm]="alumnoForm" [fechaForm]="fechaForm"
            [mostrarAutoevaluacionForm]="mostrarAutoevaluacionForm"
            [mostrarAutoevaluacion$]="mostrarAutoevaluacion$"
            (classroomActionEvent)="classroomActions($event.alumnos, $event.accion)"
            (navegarBackEvent)="navegarEstudiante(-1)">
          </app-retroalimentacion-trabajo-alumno>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
</div>
